import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { cn } from '@/lib/utils';
import { t } from '@/i18n';
import { HelpCircle } from 'lucide-react';

// "?" next to a heading or control (#113). Click or tap opens a short explanation:
// what it is and what to do. Texts live in i18n under help.<id>.title / help.<id>.text.
export const HelpTip = ({ id, className, side = 'bottom' }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button
        type="button"
        aria-label={`${t('help.label')}: ${t(`help.${id}.title`)}`}
        className={cn('print:hidden inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-muted-foreground hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring align-middle', className)}
        onClick={e => e.stopPropagation()}
      >
        <HelpCircle className="h-4 w-4" />
      </button>
    </PopoverTrigger>
    <PopoverContent side={side} align="start" className="w-72 text-sm space-y-1" onClick={e => e.stopPropagation()}>
      <div className="font-semibold">{t(`help.${id}.title`)}</div>
      <p className="text-muted-foreground leading-snug">{t(`help.${id}.text`)}</p>
    </PopoverContent>
  </Popover>
);
